import { addV6DebugInformation, clearAllV6DebugInformation } from '../../../../quotes/v6/v6-debug-information.js';
import {
  AskConfirmation,
  confirmationButtons,
  ConfirmationButtonType
} from '../../../../../webmodule-common/other/ui/modal-confirmation.js';
import { ButtonCaptionProvider, QuoteDataEntryView } from '../../../../quotes/views/quote-view.js';
import { customElement } from 'lit/decorators.js';
import { DealerReport } from '../../../../api/dealer-api-interface-clientagent.js';
import { fireQuickInformationToast } from '../../../../../webmodule-common/other/toast-away.js';
import { FranchiseeQuoteDEView, FranchiseeQuoteView } from '../franchisee-quote-view.js';
import { getApiFactory } from '../../../../api/api-injector.js';
import { getQuoteTitleStr } from '../../../../quotes/data/quote-helper-functions.js';
import { tlang } from '../../../../../webmodule-common/other/language/lang.js';
import { v6Editors, v6SupportsVersion, v6VersionMap } from '../../../../v6config/v6config.js';
import { V6PickerFamilyButton } from '../../../../../webmodule-common/interop/webmodule-interop.js';

@customElement('wm-franchiseev6quotedeview')
export class FranchiseeV6QuoteDEView extends FranchiseeQuoteDEView {
  protected clientAgentApi = getApiFactory().clientAgent();
  frameButtons: (V6PickerFamilyButton | null)[] | null = null;

  buildFrameButtons(): (ButtonCaptionProvider | null)[] {
    return this.frameButtons ?? super.buildFrameButtons();
  }

  public override async generateReportV2(dealerReport: DealerReport): Promise<boolean> {
    if (
      await AskConfirmation(
        tlang`${'ref:report-generation-draft'}You are about to generate a *draft version* of the report. Please note that this draft is intended for **internal use only** and should not be shared with customers. The report will include a visible **watermark** indicating its draft status across all pages and will not contain an official issued date.

Additionally, please be aware that the item configurations and pricing reflected in this draft are **subject to change** prior to the finalization of the quote. Ensure that this draft is utilized only for preliminary review or discussion purposes and not distributed as a finalized or customer-facing document.

Do you wish to proceed with generating the draft report?
            `,
        confirmationButtons[ConfirmationButtonType.yesNo],
        undefined,
        tlang`Generate Draft Report`
      )
    ) {
      await this.clientAgentApi.generateReport({
        id: this.quote.id,
        dealerReport: dealerReport
      });

      fireQuickInformationToast(tlang`You will be emailed a link to the document when it is ready`);
    }

    return false;
  }

  async dispose() {
    await super.dispose();

    await clearAllV6DebugInformation();

    //override if needed
  }

  public async afterConstruction(): Promise<void> {
    await super.afterConstruction();
    await this.quoteContainerManager.needsQuote();
    await this.quoteContainerManager.needsQuoteItems();
    if (v6SupportsVersion(v6VersionMap.hasMultipleFrameAdd)) {
      this.frameButtons = await v6Editors().getFramePickerButtons(this.quoteContainerManager.quote.supplierId);
    }
    await addV6DebugInformation('FranchiseeV6QuoteDEView', {
      quoteId: this.quote.id,
      quoteTitle: getQuoteTitleStr(this.quote, this.quoteContainerManager.quoteState)
    });
  }
}

@customElement('wm-franchiseev6quoteview')
export class FranchiseeV6QuoteView extends FranchiseeQuoteView {
  protected createView(): QuoteDataEntryView {
    return new FranchiseeV6QuoteDEView(this.options, this);
  }
}
